/**
 * Created by kisnows on 2016/9/29.
 */
import VerifyButton from './VeirfyButton'

export default VerifyButton
